import { Component, input } from '@angular/core';

@Component({
  selector: 'lp-spinner',
  templateUrl: 'spinner.component.html',
  styleUrl: 'spinner.component.scss',
  host: {
    '[class.with-backdrop]': 'showBackdrop()'
  }
})
export class SpinnerComponent {
  public size = input(40);
  public strokeWidth = input(4);
  public showBackdrop = input(false);
  public backdropOpacity = input(0.8);
}
